var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, TextField } from '@mui/material';
import React from 'react';
import { ShowContent } from '../ShowContent';
import { TIME_SHOW_FIELD_ERROR } from '../../util/CommonUtils';
var CustomTextField = styled(TextField)(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        '& .MuiInputBase-input': {
            textAlign: 'left',
        }
    });
});
export var DisplayCounter = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        textAlign: 'left',
        fontSize: '0.875rem',
        marginTop: '4px',
        marginLeft: '8px',
        color: '#7d7d7d'
    });
});
export var CustomInputForm = function (props) {
    var _a;
    var displayCount = props.displayCount, inputProps = props.inputProps, helperTextProp = props.helperText, errorProp = props.error, onlyNumber = props.onlyNumber, onKeyDown = props.onKeyDown, onChange = props.onChange, value = props.value, rest = __rest(props, ["displayCount", "inputProps", "helperText", "error", "onlyNumber", "onKeyDown", "onChange", "value"]);
    var maxLength = inputProps === null || inputProps === void 0 ? void 0 : inputProps.maxLength;
    var _b = React.useState(false), error = _b[0], setError = _b[1];
    var _c = React.useState(helperTextProp), helperText = _c[0], setHelperText = _c[1];
    React.useEffect(function () {
        setError(!!errorProp);
        setHelperText(helperTextProp);
    }, [errorProp, helperTextProp]);
    var handleDisplayCount = function () {
        var displayMax = maxLength ? "/".concat(maxLength) : '';
        var length = "".concat(value !== null && value !== void 0 ? value : '').length;
        return "".concat(length).concat(displayMax);
    };
    var handleKeyDown = function (event) {
        if (onlyNumber === true) {
            var allowedKeys = [
                'Backspace',
                'Delete',
                'Tab',
                'ArrowLeft',
                'ArrowRight'
            ];
            if (!allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key)) {
                event.preventDefault();
            }
        }
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
    };
    var handleChange = function (event) {
        var newValue = event.target.value;
        if (onlyNumber === true) {
            newValue = newValue.replace(/\D/g, '');
        }
        if (maxLength && newValue.length > maxLength) {
            setHelperText("O campo aceita no m\u00E1ximo ".concat(maxLength, " caracteres."));
            setError(true);
            setTimeout(function () {
                setHelperText('');
                setError(false);
            }, TIME_SHOW_FIELD_ERROR);
            return;
        }
        else {
            setHelperText(helperTextProp);
            setError(!!errorProp);
        }
        event.target.value = newValue;
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    return (_jsxs(_Fragment, { children: [_jsx(CustomTextField, __assign({}, rest, { variant: (_a = props.variant) !== null && _a !== void 0 ? _a : 'outlined', placeholder: props === null || props === void 0 ? void 0 : props.placeholder, inputProps: __assign(__assign({}, inputProps), { pattern: onlyNumber ? '[0-9]*' : inputProps === null || inputProps === void 0 ? void 0 : inputProps.pattern }), onKeyDown: handleKeyDown, onChange: handleChange, helperText: helperText, error: error, value: value, fullWidth: true })), _jsx(ShowContent, __assign({ show: displayCount === true }, { children: _jsx(DisplayCounter, { children: handleDisplayCount() }) }))] }));
};
